import { appAssetsCdnUrl } from '~/constants/environment';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

type PopularModel = {
  image: string;
  make: string;
  model: string;
  url: string;
};

const popularModels: PopularModel[] = [
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/rivian-r1t.png`,
    make: 'Rivian',
    model: 'R1S/R1T',
    url: generateSearchLinkFilter({
      filters: {
        makes: [
          { name: 'Rivian', parentModels: [{ name: 'R1S' }, { name: 'R1T' }] }
        ]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/tesla-model-3.png`,
    make: 'Tesla',
    model: 'Model 3',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Tesla', parentModels: [{ name: 'Model 3' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/chevrolet-equinox.png`,
    make: 'Chevrolet',
    model: 'Equinox',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Chevrolet', parentModels: [{ name: 'Equinox' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/nissan-rogue.png`,
    make: 'Nissan',
    model: 'Rogue',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Nissan', parentModels: [{ name: 'Rogue' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/ford-escape.png`,
    make: 'Ford',
    model: 'Escape',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Ford', parentModels: [{ name: 'Escape' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/ford-explorer.png`,
    make: 'Ford',
    model: 'Explorer',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Ford', parentModels: [{ name: 'Explorer' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/toyota-camry.png`,
    make: 'Toyota',
    model: 'Camry',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Toyota', parentModels: [{ name: 'Camry' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/honda-civic.png`,
    make: 'Honda',
    model: 'Civic',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Honda', parentModels: [{ name: 'Civic' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/nissan-altima.png`,
    make: 'Nissan',
    model: 'Altima',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Nissan', parentModels: [{ name: 'Altima' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/jeep-grand-cherokee.png`,
    make: 'Jeep',
    model: 'Grand Cherokee',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Jeep', parentModels: [{ name: 'Grand Cherokee' }] }]
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/ford-f150.png`,
    make: 'Ford',
    model: 'F-150 SuperCrew',
    url: generateSearchLinkFilter({
      filters: {
        makes: [
          {
            name: 'Ford',
            parentModels: [{ name: 'F-150' }]
          }
        ],
        truckCabTypes: ['Crew']
      }
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/home/popular-models/honda-accord.png`,
    make: 'Honda',
    model: 'Accord',
    url: generateSearchLinkFilter({
      filters: {
        makes: [{ name: 'Honda', parentModels: [{ name: 'Accord' }] }]
      }
    })
  }
];

export default popularModels;
